// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
// eslint-disable-next-line @typescript-eslint/no-var-requires
const cloneDeep = require('lodash/cloneDeep');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reducer = (state: any, action: any): any => {
  let stateCopy: any = {};
  if (action.inputList) {
    stateCopy = cloneDeep(state || {});
    action.inputList.forEach((input: any) => {
      stateCopy = handleReducer(input, stateCopy)
      console.log('Action :: ', input.type);
      console.log('State :: ', stateCopy);
    })
  } else {
    stateCopy = handleReducer(action, state || {})
    console.log('Action :: ', action.type);
    console.log('State :: ', stateCopy);
  }
  return stateCopy;
};

const handleReducer = (action: any, state: any) => {
  let stateCopy: any = {}
  switch (action.type) {
    case 'UPDATE_LOGIN':
      stateCopy = cloneDeep(state);
      stateCopy = { ...stateCopy, ...action }
      Object.keys(action).forEach((key: string) => {
        window.sessionStorage.setItem(key, action[key]);
      })
      break;
    default:
      stateCopy = cloneDeep(state);
  }
  return stateCopy;
}
